<template>
    <div>
        <a @click="openWhatsapp()" target="_blank" :href="cta_url" class="btn btn-block m-t-15 btn-lg btn-success waves-effect waves-light ladda-button">
            <span class="ladda-label">Entrar em contato por WhatsApp <i class="fab fa-whatsapp"></i></span>
        </a>
    </div>
</template>

<script>
export default {
    props: ['fk_user', 'name', 'cta_url', 'fk_property_ad'],
    methods: {
        openWhatsapp() {
            window.dataLayer.push({
                'event': 'open-whatsapp',
                'event_category': 'property_ad_page',
                'event_label': 'host-' + this.fk_user,
            });
        }
    }
}
</script>

<style>

</style>
